/* 🤖 this file was generated by svg-to-ts */
export const matIconRollerShadesClosed: {
  name: 'roller-shades-closed';
  data: string;
} = {
  name: 'roller-shades-closed',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 19V3H4v16H2v2h8.25c0 .97.78 1.75 1.75 1.75s1.75-.78 1.75-1.75H22v-2h-2zM18 5v10H6V5h12zM6 19v-2h5v2H6zm7 0v-2h5v2h-5z"/></svg>`
};
